import { IonicPage, NavParams, PopoverController, ModalController } from 'ionic-angular';
import { Component } from '@angular/core';
import { MonitoringObjectService } from '../../providers/monitoring-object-service';

/**
 * Generated class for the MessageCategoryComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@IonicPage()
@Component({
  selector: 'message-category',
  templateUrl: 'message-category.html'
})
export class MessageCategoryComponent {

  text: string;
  messageCategory: any[];
  vehicleId: number;
  loading: boolean;

  constructor(
    private monobjService: MonitoringObjectService,
    public navParams: NavParams
  ) {
    console.log('Hello MessageCategoryComponent Component');
    this.text = 'Hello World';
    this.vehicleId = this.navParams.data.componentProps.vehicleId;//.get('vehicleId');
    this.loadMessagesCategory();
  }

  async loadMessagesCategory() {
    this.loading = true;
    this.monobjService.getMessagesCategories(this.vehicleId).subscribe(data => {
      this.messageCategory = data;
      this.loading = false;
    }, err => {
      console.log(err);
      this.loading = false;
    });
  }

  messInputText: string;

  messTreeOnClick(text: string) {
    console.log("messTreeOnClick...")
    this.messInputText = text;
    this.navParams.data.componentProps.homeref.messTreeOnClick(text);
  }

}



// WEBPACK FOOTER //
// ./src/components/message-category/message-category.ts